/** Hindi: the story of a job as the two agents told it. */
export const talk = {
    "talk.title": "एजेंट की बातचीत",
    "talk.request_mine": "आपके एजेंट ने आपकी रिक्वेस्ट {name} को भेजी।",
    "talk.request_theirs": "{name} के एजेंट ने आपके एजेंट को रिक्वेस्ट भेजी।",
    "talk.asked_mine": "आपके एजेंट ने पूछा:",
    "talk.asked_theirs": "{name} के एजेंट ने पूछा:",
    "talk.answered_mine": "आपने जवाब दिया:",
    "talk.answered_theirs": "{name} ने जवाब दिया:",
    "talk.offer_mine": "आपके एजेंट ने {price} कहा।",
    "talk.offer_theirs": "{name} के एजेंट ने {price} कहा।",
    "talk.agreed": "दोनों एजेंट {price} पर राज़ी हुए।",
    "talk.signed_mine": "आपने दस्तख़त किए।",
    "talk.signed_theirs": "{name} ने दस्तख़त किए।",
    "talk.contacts": "दोनों के दस्तख़त हो गए, इसलिए आपकी संपर्क जानकारी एक-दूसरे को भेजी गई।",
    "talk.ended": "बातचीत ख़त्म हुई: {reason}",
    "talk.private_provider": "आपका सबसे कम दाम कभी भेजा नहीं गया। वह इसी फ़ोन पर रहा।",
    "talk.private_requester": "आपका बजट कभी भेजा नहीं गया। वह इसी फ़ोन पर रहा।",
    "decide.takeover_title": "आपके एजेंट सहमत नहीं हो पाए",
    "decide.takeover_body": "तीन-तीन बार की पेशकश के बाद अब फ़ैसला आपका है। उनकी आख़िरी पेशकश: {price}।",
    "decide.accept_theirs": "{price} मान लें",
    "decide.your_offer": "आपकी पेशकश (₹)",
    "decide.send_offer": "मेरी पेशकश भेजें",
    "decide.end": "बातचीत ख़त्म करें",
    "decide.time_title": "दूसरा समय",
    "decide.time_other": "{name} आपके माँगे समय की जगह {when} आ सकते हैं।",
    "decide.time_passed": "आपका माँगा समय निकल चुका है।",
    "decide.time_passed_other": "आपका माँगा समय निकल चुका है। {name} {when} आ सकते हैं।",
    "decide.accept_time": "हाँ, {when}",
    "decide.pick_time": "दूसरा समय चुनें",
    "decide.pick_send": "यह समय भेजें",
    "a11y.takeover": "आपके एजेंट सहमत नहीं हो पाए",
    "a11y.new_time": "दूसरा समय",
    "talks.take_over": "अपने एजेंट से बातचीत अपने हाथ में लें",
};
//# sourceMappingURL=talk.js.map